import { Box } from '@mui/material';
import React from 'react';

const MoneyReciveIcon = ({ ...rest }) => (
  <Box {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4 21.6669H14.8933C13.12 21.6669 11.6667 20.1736 11.6667 18.3336C11.6667 17.7869 12.12 17.3336 12.6667 17.3336C13.2133 17.3336 13.6667 17.7869 13.6667 18.3336C13.6667 19.0669 14.2133 19.6669 14.8933 19.6669H17.4C17.92 19.6669 18.3333 19.2003 18.3333 18.6269C18.3333 17.9069 18.1333 17.8003 17.68 17.6403L13.6667 16.2403C12.8133 15.9469 11.6667 15.3203 11.6667 13.3603C11.6667 11.6936 12.9867 10.3203 14.6 10.3203H17.1067C18.88 10.3203 20.3333 11.8136 20.3333 13.6536C20.3333 14.2003 19.88 14.6536 19.3333 14.6536C18.7867 14.6536 18.3333 14.2003 18.3333 13.6536C18.3333 12.9203 17.7867 12.3203 17.1067 12.3203H14.6C14.08 12.3203 13.6667 12.787 13.6667 13.3603C13.6667 14.0803 13.8667 14.1869 14.32 14.3469L18.3333 15.7469C19.1867 16.0403 20.3333 16.6669 20.3333 18.6269C20.3333 20.3069 19.0133 21.6669 17.4 21.6669Z"
        fill="#8689AC"
      />
      <path
        d="M16 23C15.4533 23 15 22.5467 15 22V10C15 9.45333 15.4533 9 16 9C16.5467 9 17 9.45333 17 10V22C17 22.5467 16.5467 23 16 23Z"
        fill="#8689AC"
      />
      <path
        d="M16 30.3334C8.09333 30.3334 1.66667 23.9067 1.66667 16.0001C1.66667 8.09341 8.09333 1.66675 16 1.66675C16.5467 1.66675 17 2.12008 17 2.66675C17 3.21341 16.5467 3.66675 16 3.66675C9.2 3.66675 3.66667 9.20008 3.66667 16.0001C3.66667 22.8001 9.2 28.3334 16 28.3334C22.8 28.3334 28.3333 22.8001 28.3333 16.0001C28.3333 15.4534 28.7867 15.0001 29.3333 15.0001C29.88 15.0001 30.3333 15.4534 30.3333 16.0001C30.3333 23.9067 23.9067 30.3334 16 30.3334Z"
        fill="#8689AC"
      />
      <path
        d="M28 10.3333H22.6667C22.12 10.3333 21.6667 9.88 21.6667 9.33333V4C21.6667 3.45333 22.12 3 22.6667 3C23.2133 3 23.6667 3.45333 23.6667 4V8.33333H28C28.5467 8.33333 29 8.78667 29 9.33333C29 9.88 28.5467 10.3333 28 10.3333Z"
        fill="#8689AC"
      />
      <path
        d="M22.666 10.3333C22.4127 10.3333 22.1593 10.2399 21.9593 10.0399C21.5727 9.65325 21.5727 9.01326 21.9593 8.62659L28.626 1.95992C29.0127 1.57326 29.6527 1.57326 30.0393 1.95992C30.426 2.34659 30.426 2.98659 30.0393 3.37326L23.3727 10.0399C23.1727 10.2399 22.9193 10.3333 22.666 10.3333Z"
        fill="#8689AC"
      />
    </svg>
  </Box>
);

export default MoneyReciveIcon;
